import * as xlsx from "xlsx";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import fire from "./Firebase";
import { click } from "@testing-library/user-event/dist/click";
import Adminheader from "../Adminheader";
function Uploadfile() {
  document.title = "HR School - Upload File";
  const [excel, setexcel] = useState([]);

  const [certificate, setcertificate] = useState();
  const navigate = useNavigate();
  function logout() {
    toast.success("ID is Logout");
    setTimeout(() => {
      navigate("/");
    }, 200);
  }
  function click(e) {
    setcertificate({ ...certificate, [e.target.name]: e.target.value });
  }
  function save() {
    fire.child("certificates").push(certificate, (error) => {
      if (certificate == null) {
        toast.error("Fill All Details");
      } else {
        toast.success("Success");
        window.location.reload(false);
      }
    });
  }
  const changedata = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);

        setexcel(json);
        console.log(json);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };
  const uploadexcel = () => {
    fire.child("excelcerti").push(excel, (error) => {
      if (excel == null) {
        toast.error("Fill All Details");
      } else {
        toast.success("Success");
        window.location.reload(false);
      }
    });
  };
  return (
    <div>
     <Adminheader/>
      <div className="container-fluid mimin-wrapper">
        {/* start:Left Menu */}
        <div id="left-menu">
          <div className="sub-left-menu scroll">
            <div className="wheather">
              {" "}
              <br />
              <br />
              <div
                className="stormy rainy animated pulse infinite"
                title="Hero"
              >
                <div className="shadow">Mr.H</div>
              </div>
              <div className="sub-wheather">
                <div className="thunder"></div>
                <div className="rain">
                  <div className="droplet droplet1" />
                  <div className="droplet droplet2" />
                  <div className="droplet droplet3" />
                  <div className="droplet droplet4" />
                  <div className="droplet droplet5" />
                  <div className="droplet droplet6" />
                </div>
              </div>
            </div>
            <ul className="nav nav-list">
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="/profile">
                  DashBoard
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="/uploadpic">
                  Upload Image
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="/uploadfile">
                  Upload Certificate
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link to="/viewcontact" className="tree-toggle nav-header">
                  View Contact
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
              <li className="active ripple">
                <Link className="tree-toggle nav-header" to="" onClick={logout}>
                  Logout
                  <span className="fa-angle-right fa right-arrow text-right" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* end: Left Menu */}
        {/* start: content */}

        {/* end: content */}
        {/* start: right menu */}
      </div>{" "}
      <br />
      <div id="content">
        <br />
        <br />
        <br />
        <br />
        <center>
          <div className="App">
            <select name="Field" onChange={click}>
              <option disabled="disabled">SELECT</option>
              <option name="HEALTH" onChange={click}>
                HEALTH
              </option>
              <option name="IT" onChange={click}>
                IT
              </option>
              <option name="BUSINESS" onChange={click}>
                BUSINESS
              </option>
              <option name="MECHANICAL" onChange={click}>
                MECHANICAL{" "}
              </option>
            </select>
            {/* <input
              type="text"
              onChange={click}
              placeholder="Field e.g IT,Health"
              name="Field"
            />{" "} */}
            <br />
            <br />
           
            <select
              name="Gender"
              id=""
              placeholder="Select"
              onChange={click}
              style={{ margin: "10px" }}
            >
              <option selected="true" disabled="disabled">
                Choose
              </option>
              <option name="Mr." onChange={click}>
                Mr.
              </option>
              <option name="Ms." onChange={click}>
                Ms.
              </option>
              <option name="Mrs." onChange={click}>
                Mrs.
              </option>
              <option name="Miss." onChange={click}>
                Miss
              </option>
            </select>
            <input
              type="text"
              onChange={click}
              placeholder="Name"
              name="Name"
              style={{ margin: "10px" }}
            />{" "}
            <input
              type="text"
              onChange={click}
              placeholder="Father Name"
              name="Father"
            />
            <br />
            <br />
            <h1>
              <strong>CERTIFICATE DETAILS</strong>
            </h1>{" "}
            <br />
            <input
              type="number"
              onChange={click}
              placeholder="Course Duration"
              name="Course"
              style={{ margin: "10px" }}
            />
            <input
              type="text"
              onChange={click}
              placeholder="Course Name"
              name="Coursename"
              style={{ margin: "10px" }}
            />
            <input
              type="text"
              onChange={click}
              placeholder="Grade eg. A, A+, B"
              name="grade"
            />
            <br />
            <br />
            <h3>Course Start Date</h3> <br />
            <input
              type="number"
              onChange={click}
              placeholder="Start Date"
              name="startdate"
              style={{ margin: "10px" }}
            />
            <input
              type="text"
              onChange={click}
              placeholder="Start Month"
              name="startmonth"
              style={{ margin: "10px" }}
            />
            <input
              type="number"
              onChange={click}
              placeholder="Start Year"
              name="startyear"
              style={{ margin: "10px" }}
            />
            <br />
            <br />
            <h3>Course End Date</h3> <br />
            <input
              type="number"
              onChange={click}
              placeholder="End Date"
              name="enddate"
              style={{ margin: "10px" }}
            />
            <input
              type="text"
              onChange={click}
              placeholder="End Month"
              name="endmonth"
              style={{ margin: "10px" }}
            />
            <input
              type="number"
              onChange={click}
              placeholder="End Year"
              name="endyear"
              style={{ margin: "10px" }}
            />
            <br />
            <br />
            <br />
            <button onClick={save}>Save</button>
            <h1>Upload Excel</h1>
            <input type="file" onChange={changedata} /> <br />
            <br />
            <button onClick={uploadexcel}>Upload Excel</button> <br />
            <br />
            {/* {
  excel.map(daa=>{
    console.log(daa)
  return(
    <p>{daa.Name}</p>
  )
  })
} */}
          </div>
        </center>
      </div>
    </div>
  );
}

export default Uploadfile;
